<template>
  <div>
    <home-join-banner></home-join-banner>
    <!--<div class="bg-container">-->
      <div class="container">
          <home-join-navi></home-join-navi>
          <router-view></router-view>
      </div>
    </div>
  <!--</div>-->

</template>

<script>
  import HomeJoinNavi from './HomeJoinNavi'
  import HomeJoinContent from './HomeJoinContent'
  import HomeJoinBanner from './HomeJoinBanner'
  export default {
    components: {HomeJoinBanner, HomeJoinContent, HomeJoinNavi}, name: 'join_us'
  }
</script>

<style scoped>
  /*.bg {*/
  /*display: flex;*/
  /*}*/
  .bg-container {
    width: 1100px;
    display: flex;
    margin: auto;
    background-color: rgb(255, 255, 255);
  }

  .container {
    width: 1100px;
    padding: 0;
    margin: auto;
  }

  /*.content {*/
    /*width: 1100px;*/
    /*margin: auto;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// HomeJoinUs.vue?8c03ebca